import type { StockRow } from '@econtractor/types';
import EmptyResult from "components/others/EmptyResult";
import StockTableRows from "./StockTableRows";

interface WarehouseTableBodyProps {
    wId: number | string;
    stocksList: StockRow[] | null;
    setShowTransfer: (show: boolean | number | 'all') => void;
    setShowComing: (show: boolean | number) => void;
    setShowPaymentsId: (id: number | null) => void;
    setShowPaymentsTitle: (title: string | null) => void;
    onlyView: boolean;
    showBalanceColumn?: boolean;
}

const WarehouseTableBody = ({
    wId,
    stocksList,
    setShowTransfer,
    setShowComing,
    setShowPaymentsId,
    setShowPaymentsTitle,
    onlyView,
    showBalanceColumn = false,
}: WarehouseTableBodyProps) => {
    const colSpan = (onlyView ? 5 : 6) + (showBalanceColumn ? 1 : 0);

    return (<>
        <tbody>
        {stocksList && stocksList?.map((stock) => {
            return (
                <StockTableRows
                    wId={wId}
                    onlyView={onlyView}
                    setShowTransfer={setShowTransfer}
                    setShowComing={setShowComing}
                    setShowPaymentsId={setShowPaymentsId}
                    setShowPaymentsTitle={setShowPaymentsTitle}
                    key={stock.ID} 
                    stock={stock}/>
            )
        })}

        
        {(!stocksList || stocksList.length === 0) && (
            <tr>
                <td colSpan={colSpan}>
                    <EmptyResult/>
                </td>
            </tr>)}
        </tbody>
        
    </>) 
}

export default WarehouseTableBody;
